import { _ as b } from "./objectWithoutPropertiesLoose-2ffc4b6d.js";
import "./es.object.assign-7e79fd7b.js";
import { c as l } from "./index-8b07dec9.js";
import "./es.object.keys-9d66766f.js";
import "@ucl/shared-component-foundations";
import { useContext as _, createElement as x } from "react";
import "./es.array.filter-4e9c9996.js";
import "./es.array.concat-d1c9b847.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./es.array.map-d821aaf5.js";
import "./es.object.entries-d2a19275.js";
import "./es.object.to-string-f55666a8.js";
import "./es.string.replace-f4cc3aea.js";
import { _ as f } from "./cloneSlots-622cf8c9.js";
import "./web.dom-collections.for-each-3020ed11.js";
import "./web.set-timeout-72b6430f.js";
import "./es.array.some-0c761b6d.js";
import "./es.array.every-3d11adb5.js";
import "./useScroll.js";
import { useSlots as h } from "./useSlots.js";
import "./createClass-57dcdeea.js";
import "./es.date.to-json-b76d522e.js";
import { T as N } from "./tabs.provider-ae82732d.js";
import d, { css as T } from "styled-components";
import { jsx as u } from "react/jsx-runtime";
import "./export-cdcbfb2b.js";
import "./object-keys-719a5561.js";
import "./array-iteration-759bfbfa.js";
import "./create-property-f9780ed1.js";
import "./object-create-9b6715a2.js";
import "./html-32ef1b46.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./is-regexp-4c49b1c2.js";
import "./to-string-92a62764.js";
import "./classof-21a3574e.js";
import "./iterate-13ada9e5.js";
import "./object-to-array-0474b7e7.js";
import "./object-set-prototype-of-7d7e5736.js";
import "./function-uncurry-this-clause-99074d1c.js";
import "./function-apply-4756dee6.js";
import "./es.array.is-array-7a29277f.js";
import "./array-method-is-strict-e5a3c878.js";
import "./environment-ddee5959.js";
import "./array-slice-79f93c56.js";
import "./validate-arguments-length-eb516e5b.js";
import "./getTarget-19e0f923.js";
import "./useEventListener.js";
import "./isClient-2f5bedbd.js";
import "./useOverFlown.js";
import "./useResizeObserver.js";
import "./isApiSupported-66660265.js";
import "./useIsMounted.js";
var C = /* @__PURE__ */ d.div.withConfig({
  displayName: "tabPanelsstyles__TabPanels",
  componentId: "sc-5imise-0"
})(["&.Tabs__tab-content-wrapper{", ";}"], function(r) {
  var t = r.theme.components.tabs;
  return T(t.TabPanels);
}), y = /* @__PURE__ */ d.div.withConfig({
  displayName: "tabPanelsstyles__TabPanel",
  componentId: "sc-5imise-1"
})(["&.TabPanel{", ";}"], function(r) {
  var t = r.theme.components.tabs;
  return T(t.TabPanel);
}), $ = ["children", "className", "index"], v = function(t) {
  var p = t.children, n = t.className, m = t.index, i = m === void 0 ? 0 : m, a = b(t, $), e = _(N), o = e.activeTabIndex, s = o === void 0 ? 0 : o, c = e.id;
  return s !== i ? null : /* @__PURE__ */ u(y, Object.assign({
    id: "tabpanel-" + c + "-" + i,
    "aria-labelledby": "tab-" + c + "-" + i,
    className: l(["TabPanel", n])
  }, a, {
    children: p
  }));
}, g = ["children"], P = function(t) {
  var p = t.children, n = b(t, g), m = h(p, {
    panel: P.Content
  }), i = f(m.panel, function(a, e) {
    var o, s;
    return /* @__PURE__ */ x(v, Object.assign({}, a, {
      key: e,
      index: (o = a.index) != null ? o : e,
      className: l(["TabPanels__Content", "TabPanels__Content-" + ((s = a.index) != null ? s : e), a.className])
    }));
  });
  return /* @__PURE__ */ u(C, Object.assign({}, n, {
    className: l(["TabPanels", n.className]),
    role: "tabpanel",
    children: i
  }));
};
P.Content = v;
export {
  v as TabPanel,
  P as TabPanels
};
